var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCpcSess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6363_359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 6C4.4087 6 2.88258 6.63214 1.75736 7.75736C0.632141 8.88258 0 10.4087 0 12L0 36C0 37.5913 0.632141 39.1174 1.75736 40.2426C2.88258 41.3679 4.4087 42 6 42H21.729C22.095 41.022 22.614 39.996 23.307 39H6C5.20435 39 4.44129 38.6839 3.87868 38.1213C3.31607 37.5587 3 36.7956 3 36V12C3 11.2044 3.31607 10.4413 3.87868 9.87868C4.44129 9.31607 5.20435 9 6 9H42C42.7956 9 43.5587 9.31607 44.1213 9.87868C44.6839 10.4413 45 11.2044 45 12V35.43C46.059 36.12 46.968 36.918 47.73 37.779C47.91 37.217 48 36.624 48 36V12C48 10.4087 47.3679 8.88258 46.2426 7.75736C45.1174 6.63214 43.5913 6 42 6H6Z",
    fill: "#005350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1014 50.8769C44.1014 45.602 39.8254 41.3262 34.5507 41.3262C29.276 41.3262 25 45.602 25 50.8769",
    stroke: "#EA7F4A",
    strokeWidth: 3.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7734 31.7754C29.7734 33.0419 30.2766 34.2565 31.1721 35.152C32.0677 36.0476 33.2823 36.5507 34.5488 36.5507C35.8153 36.5507 37.0299 36.0476 37.9255 35.152C38.821 34.2565 39.3242 33.0419 39.3242 31.7754C39.3242 30.5089 38.821 29.2942 37.9255 28.3987C37.0299 27.5031 35.8153 27 34.5488 27C33.2823 27 32.0677 27.5031 31.1721 28.3987C30.2766 29.2942 29.7734 30.5089 29.7734 31.7754Z",
    stroke: "#EA7F4A",
    strokeWidth: 3.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6363_359"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpcSess);
export default __webpack_public_path__ + "static/media/cpc-sess.e3cc0abd120e5db628de4ec9e823f894.svg";
export { ForwardRef as ReactComponent };